/*
 *  Copyright (c) 2021.
 *  This file is part of the Compo B2B application.
 *  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 *  For the full copyright and license information, please view the LICENSE
 *  file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {ListFilterService} from "compob2b-libs";

@Injectable({
  providedIn: 'root'
})
export class DamFilterService extends ListFilterService {
  skipFields = ['templateId'];
}
